import { API_URLS } from "../constants";
import { postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";

const { MARKETING_SALES_REPORT } = API_URLS;

const getCampaignMetricsData = (body) => {
  return postRequest(
    MARKETING_SALES_REPORT.CAMPAIGN_METRICS_PAGINATED_DATA,
    body
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getSalesReport = (body) => {
  return postRequest(MARKETING_SALES_REPORT.MARKETING_SALES_DATA, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getTotalEmailAndSmsDeliveredCount = (body) => {
  return postRequest(
    MARKETING_SALES_REPORT.TOTAL_EMAILS_AND_SMS_DELIEVERED_COUNT,
    body
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const marketingSalesService = {
  getSalesReport,
  getCampaignMetricsData,
  getTotalEmailAndSmsDeliveredCount,
};
